/** Erro de entrada inválida do motor de preço. A mensagem é exibida ao usuário. */
export class ErroPreco extends Error {
  readonly campo: string;

  constructor(campo: string, mensagem: string) {
    super(mensagem);
    this.name = "ErroPreco";
    this.campo = campo;
  }
}
